import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/student-book-report/StudentBookReportAction";
import * as uiHelpers from "../BookAndPageNumberUIHelpers";
import { 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useBookAndPageNumberUIContext } from "../BookAndPageNumberUIContext";

export function BookAndPageNumberTable() {
  // Book And Page Number UI Context
  const bookAndPageNumberUIContext = useBookAndPageNumberUIContext();
  const bookAndPageNumberUIProps = useMemo(() => {
    return {
      queryParams: bookAndPageNumberUIContext.queryParams,
      setQueryParams: bookAndPageNumberUIContext.setQueryParams
    };
  }, [bookAndPageNumberUIContext]);

  // Getting curret state of Book And Page Number list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentBookReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Book And Page Number Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    if (bookAndPageNumberUIProps.queryParams.term) dispatch(actions.getBookAndPageNumberReport(bookAndPageNumberUIProps.queryParams));
    return () => dispatch(actions.cleanStudentBookReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookAndPageNumberUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "bookCount",
      text: "Kitap Sayısı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "pageNumberCount",
      text: "Sayfa Sayısı",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: bookAndPageNumberUIProps.queryParams.pageSize,
    page: bookAndPageNumberUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                bookAndPageNumberUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}